module.exports = __webpack_public_path__ + "static/media/activity_type_creatief_inverted.296cae02.svg";